//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum CirclePrivacyType {

  /**
   * No privacy set. Allow instant book.
   */
  Public = 0,

  /**
   * No instant book. Must be in circle to book. May request to be in circle.
   */
  Private = 1,

}

export default CirclePrivacyType;